'use strict';

function buildMediaQuery(_ref, not) {
  var minWidth = _ref.minWidth;
  var maxWidth = _ref.maxWidth;

  var query = '';

  if (minWidth) {
    query += '(min-width: ' + minWidth + ')';
  }

  if (minWidth && maxWidth) {
    query += ' and ';
  }

  if (maxWidth) {
    query += '(max-width: ' + maxWidth + ')';
  }

  if (not) {
    query = 'not all and ' + query;
  }

  return query;
}

module.exports = buildMediaQuery;


/*****************
 ** WEBPACK FOOTER
 ** ./~/cf-component-viewport/lib/buildMediaQuery.js
 ** module id = 371
 ** module chunks = 0
 **/